import React, { Component } from 'react';

/*Material ui template */
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import InputLabel from '@material-ui/core/InputLabel';


export default class CloseOutWorked extends Component {
  
  static propTypes = {

  };

  state = {
  };

  render() {
    return (
      <React.Fragment>
        <Typography variant="h6" gutterBottom>
          Schedule
        </Typography>
        <Grid container spacing={24}>
          <Grid item xs={8} sm={4}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Original Project Start Date:</InputLabel>
              <Typography gutterBottom variant="h6">
              {this.props.report.planned_start_date}
            </Typography>
          </Grid>
          <Grid item xs={8} sm={4}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Planned project Finish Date:</InputLabel>
              <Typography gutterBottom variant="h6">
              {this.props.report.planned_end_date}
            </Typography>
          </Grid>
          <Grid item xs={8} sm={4}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Planned project duration:</InputLabel>
              <Typography gutterBottom variant="h6">
              {this.props.report.planned_duration}
            </Typography>
          </Grid>
          <Grid item xs={8} sm={4}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Actual Project Start Date:</InputLabel>
              <Typography gutterBottom variant="h6" >
              {this.props.report.actual_start_date}
            </Typography>
          </Grid>
          <Grid item xs={8} sm={4}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Actual Project Finish Date:</InputLabel>
              <Typography gutterBottom variant="h6" >
              {this.props.report.actual_end_date}
            </Typography>
          </Grid>
          <Grid item xs={8} sm={4}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Actual project duration:</InputLabel>
              <Typography gutterBottom variant="h6">
              {this.props.report.actual_duration}
            </Typography>
          </Grid>
          <Grid item xs={8} sm={4}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Variance(Days):</InputLabel>
              <Typography gutterBottom variant="h6" style={{color:"#4F74B7"}}>
              {this.props.report.variance_start_date}
            </Typography>
          </Grid>
          <Grid item xs={8} sm={4}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Variance(Days):</InputLabel>
              <Typography gutterBottom variant="h6" style={{color:"#4F74B7"}}>
              {this.props.report.variance_end_date}
            </Typography>
          </Grid>
          <Grid item xs={8} sm={4}>
            <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Project was:</InputLabel>
              <Typography gutterBottom variant="h6" style={{color:"#4F74B7"}}>
              {this.props.report.schedule}
            </Typography>
          </Grid>
        </Grid>
  </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/home/CloseOutSchedule.js